import { useAppSelector } from "../Redux/store";
import { TalentSpecializations } from "../Types/General";
import { Talent } from "../Types/Talent"

interface useTalentFiltersProps {}

export const useTalentFilters = () => {
    /* ******************** Hooks ******************** */
    const filters = useAppSelector(state => state.TalentMarketplaceFilters);
    /* ******************** Variables ******************** */
    /* ******************** Functions ******************** */
    const getSpecialization = (expertise: string) => {
        return TalentSpecializations.find( s => s.roles.includes(expertise))?.label ?? ""
    }
    const containsSkill = (skills: string[], filters: string[]) => {
        const trimmedSkills = skills.map( s => s.trim().toLowerCase());
        const skillSet = new Set(trimmedSkills);
        return filters.some( f => skillSet.has(f.toLowerCase()));
    }
    const filterTalents = (talents: Talent[]) => {
        let filteredTalents = talents;
        if (filters.Skill.length > 0) {
            filteredTalents =  filteredTalents.filter( t => containsSkill(t?.resume?.skills ?? [], filters.Skill));
        };
        if (filters.Level.length > 0) filteredTalents = filteredTalents.filter( t => t?.resume?.expertise?.expertise_level === filters.Level);
        if (filters.Specialization.length > 0) filteredTalents = filteredTalents.filter( t => TalentSpecializations.find( s=> s.roles.includes(t?.resume?.expertise?.primary_expertise))?.label === filters.Specialization);
        if (filters.WorkSite.length > 0) filteredTalents = filteredTalents.filter( t => t?.work_preferences?.site.includes(filters.WorkSite));   
        return filteredTalents;
    }
    /* ******************** Effects ******************** */
    /* ******************** JSX ******************** */
    return {
        filterTalents,
        getSpecialization
    }
}